import * as mapboxgl from 'mapbox-gl';

export class MapboxButtonControl implements mapboxgl.IControl {// extends mapboxgl.Control {

	private _className: string;
	private _title: string;
	private _iconClassName: string;
	private _eventHandler: (event: Event) => void;

	private _map: mapboxgl.Map;

	private _icon: HTMLElement;
	private _btn: HTMLButtonElement;
	private _container: HTMLDivElement;

  constructor(
		options?: {
			className?: string,
    	title?: string,
			iconClassName?: string,
    	eventHandler?: (event: Event) => void
  	}
	) {
    this._className = options.className;
    this._title = options.title;
		this._iconClassName = options.iconClassName;
    this._eventHandler = options.eventHandler;
  }

  onAdd(map: mapboxgl.Map): HTMLElement {
		this._map = map;

		this._icon = document.createElement("i");
		this._icon.className = this._iconClassName;

    this._btn = document.createElement("button");
    this._btn.className = `mapboxgl-ctrl-icon ${this._className}`;
		this._btn.style.cssText = `background-repeat: no-repeat; background-position: center; pointer-events: auto;`;
    this._btn.type = "button";
    this._btn.title = this._title;
    this._btn.onclick = this._eventHandler;
		this._btn.appendChild(this._icon);

    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._btn);

    return this._container;
  }

  onRemove(map: mapboxgl.Map): void {
    this._container.parentNode.removeChild(this._container);
		this._map = undefined;
  }
}
